import { ChevronRight as ChevronRightIcon } from "@/assets/icons/24/ChevronRight";
import { MegaMenuItemData } from "@/common/contracts/mega-menu.contracts";
import { AccountMenuMobilePanel } from "@/components/Account/common/AccountMenuMobilePanel";
import { MegaMenuMobileItemIcon } from "@/components/mega-menu/mobile/MegaMenuMobileItem";
import { Flavor } from "@/ui/typography/Flavor";

type MegaMenuMobileAccountItemProps = {
  /** The CMS "Account" item: only its icon and label are used. */
  item: MegaMenuItemData;
  /** Runs when the row is tapped (analytics). */
  onClick?: () => void;
  /** Close-all callback of the hamburger menu. */
  onClose?: () => void;
};

/**
 * WHO-5453 round 4, F15. Hamburger row that opens the grouped account menu
 * for a logged-in user. Looks like any other submenu row; the panel behind it
 * is the code-defined account navigation, not the CMS list.
 */
export const MegaMenuMobileAccountItem = ({
  item,
  onClick,
  onClose,
}: MegaMenuMobileAccountItemProps) => {
  return (
    <li>
      <AccountMenuMobilePanel
        hasBack
        onClose={onClose}
        trigger={
          <button
            type="button"
            className="flex w-full items-center space-x-2 text-left"
            onClick={onClick}
          >
            <MegaMenuMobileItemIcon item={item} />
            <Flavor className="flex-1">{item.label}</Flavor>
            <ChevronRightIcon />
          </button>
        }
      />
    </li>
  );
};
